import request from '@/config/axios'

export interface SaasDistProfileVO {
  userId: number
  inviteCode: string
  distributionEnabled: boolean
  inviteUrl?: string
}

export interface SaasDistRelationVO {
  id: number
  inviterUserId: number
  /** 分销用户昵称 */
  inviterNickname?: string
  customerTenantId?: number
  /** 关联租户名称 */
  customerTenantName?: string
  companyName: string
  contactName: string
  contactMobile: string
  inviteCodeUsed: string
  remark?: string
  /** 0 拉取 / 1 成立 */
  status: number
  pulledAt?: string
  establishedAt?: string
  tenantStatus?: number
}

export interface SaasDistPullReqVO {
  companyName: string
  contactName: string
  contactMobile: string
  remark?: string
}

export interface SaasDistRelationPageReqVO {
  pageNo?: number
  pageSize?: number
  status?: number
  companyName?: string
  contactMobile?: string
  all?: boolean
}

export interface SaasDistMatchPrecheckVO {
  matched: boolean
  message: string
  relationId?: number
  inviterUserId?: number
  inviterNickname?: string
  companyName?: string
  contactName?: string
  contactMobile?: string
  inviteCodeUsed?: string
}

export interface SaasDistRebindReqVO {
  tenantId: number
  inviteCode: string
  contactMobile: string
  reason?: string
}

export const getSaasDistProfile = () => {
  return request.get<SaasDistProfileVO>({ url: '/platform-dist/saas-dist/profile' })
}

export const getSaasDistRelationPage = (params: SaasDistRelationPageReqVO) => {
  return request.get({ url: '/platform-dist/saas-dist/relation/page', params })
}

export const pullSaasDistCustomer = (data: SaasDistPullReqVO) => {
  return request.post({ url: '/platform-dist/saas-dist/pull', data })
}

export const matchSaasDistPrecheck = (params: { contactMobile?: string; inviteCode?: string }) => {
  return request.get<SaasDistMatchPrecheckVO>({ url: '/platform-dist/saas-dist/match-precheck', params })
}

export const rebindSaasDist = (data: SaasDistRebindReqVO) => {
  return request.post({ url: '/platform-dist/saas-dist/rebind', data })
}
